import type { FC } from 'react'

import { NoResults } from '@features/algolia.modals/Search/NoResults/NoResults'
import {
  getSearchPropsFromResultsData,
  type ResultProps,
} from '@features/algolia.modals/Search/Results/Results'
import { useReadQuery } from '@shared/apollo'
import useTranslation from 'next-translate/useTranslation'

import { SearchResultItem } from '../SearchResult'

export const SearchResults: FC<ResultProps> = ({ queryRef }) => {
  const { t } = useTranslation('common')
  const { data } = useReadQuery(queryRef)

  if (data.search.results.length === 0) {
    return <NoResults searchKey={data.search.searchKey || ''} />
  }
  return (
    <>
      <div className="pb-4 pt-6 type-h-section-md">
        {t('notFound.searchResultTitle')}
      </div>
      <div className="grid grid-flow-row grid-cols-1 gap-4 sm:grid-cols-2">
        {data.search.results.map((searchResultItem) =>
          searchResultItem ? (
            <SearchResultItem
              key={searchResultItem.objectID}
              {...getSearchPropsFromResultsData(searchResultItem)}
            />
          ) : null,
        )}
      </div>
    </>
  )
}
